import { render, staticRenderFns } from "./CameraInfo.vue?vue&type=template&id=066f327a&scoped=true"
import script from "./CameraInfo.vue?vue&type=script&lang=js"
export * from "./CameraInfo.vue?vue&type=script&lang=js"
import style0 from "./CameraInfo.vue?vue&type=style&index=0&id=066f327a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066f327a",
  null
  
)

export default component.exports